export default "__VITE_ASSET__DjAsLuB___"